import React from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import CateringReward from "assets/images/icons/catering-rewards/cr-logo-black.png";
import NoDataImage from "assets/images/icons/catering-rewards/nodata-image.svg";

function NotFound() {
  const handleGoHome = () => {
    window.open("https://cateringrewards.com/", "_blank");
  };

  return (
    <div className="mainBackgroundColor">
      {/* Header */}
      <MDBox
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1100,
          py: 1.5,
          px: 3,
          display: "flex",
          alignItems: "center",
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          backdropFilter: "blur(10px)",
          borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
        }}
      >
        <img src={CateringReward} alt="Catering Rewards" style={{ height: 50 }} />
      </MDBox>
      <MDBox sx={{ height: "72px" }} />

      {/* Content */}
      <MDBox
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "calc(100vh - 72px)",
          textAlign: "center",
          px: 3,
          py: 5,
        }}
      >
        <MDBox
          mb={4}
          component="img"
          src={NoDataImage}
          alt="Not Found"
          width="100%"
          maxWidth="300px"
        />

        <MDTypography variant="h3" fontWeight="bold" mb={2} color="text">
          Oops! Page Not Found
        </MDTypography>

        <MDTypography
          variant="body1"
          color="text"
          sx={{ maxWidth: 500, lineHeight: 1.6, mb: 4, opacity: 0.8 }}
        >
          The page you are looking for might have been removed, had its name changed, or is
          temporarily unavailable. Please check the URL or try again later.
        </MDTypography>

        <MDButton variant="gradient" color="success" size="large" onClick={handleGoHome}>
          Visit Catering Rewards
        </MDButton>
      </MDBox>
    </div>
  );
}

export default NotFound;
